import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Alert,
  Form,
  Input,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import FeatherIcon from "feather-icons-react";
import bgImage from "../../../assets/images/app/bg-image.png";

class AccountDeletion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      email: "",
      password: "",
      reasonForDeletion: "",
      loading: false,
      errormessage: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true, success: false, errormessage: "" });

    const payload = {
      email: this.state.email,
      password: this.state.password,
      reasonForDeletion: this.state.reasonForDeletion,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "https://api.digitcardapp.com"}/api/user/request-delete-account`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        this.setState({
          success: true,
          email: "",
          password: "",
          reasonForDeletion: "",
        });
      } else {
        const errorData = await response.json().catch(() => ({}));
        this.setState({ errormessage: errorData.message || "Failed to submit request. Please try again later." });
      }
    } catch (error) {
      this.setState({ errormessage: "Failed to connect to the server. Please check your internet connection." });
    } finally {
      this.setState({ loading: false });
    }
  }

  componentDidMount() {
    document.body.classList = "";
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById("topnav");
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add("nav-sticky");
      } else {
        navBar.classList.remove("nav-sticky");
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <section
          className="bg-half-170 bg-light d-table w-100"
          style={{ background: `url(${bgImage}) center center` }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={12} className="text-center">
                <div className="pages-heading">
                  <h4 className="title mb-0"> Account Deletion Request </h4>
                </div>
              </Col>
            </Row>

            <div className="position-breadcrumb">
              <nav aria-label="breadcrumb" className="d-inline-block">
                <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Account Deletion</li>
                </ul>
              </nav>
            </div>
          </Container>
        </section>

        <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>

        <section className="section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8}>
                <Card className="shadow rounded border-0">
                  <CardBody className="py-5">
                    <h4 className="card-title text-center">Delete Your Account</h4>
                    <p className="text-muted text-center">
                      Please provide your details to request account deletion. This action is irreversible.
                    </p>
                    <div className="custom-form mt-4">
                      {this.state.success && (
                        <Alert color="success">
                          Your account deletion request has been submitted successfully.
                        </Alert>
                      )}
                      {this.state.errormessage && (
                        <Alert color="danger">
                          {this.state.errormessage}
                        </Alert>
                      )}
                      <Form onSubmit={this.handleSubmit}>
                        <Row>
                          <Col md={12}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Email Address <span className="text-danger">*</span>
                              </Label>
                              <div className="form-icon position-relative">
                                <i>
                                  <FeatherIcon
                                    icon="mail"
                                    className="fea icon-sm icons"
                                  />
                                </i>
                                <Input
                                  name="email"
                                  type="email"
                                  className="form-control ps-5"
                                  placeholder="Email Address"
                                  value={this.state.email}
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Password <span className="text-danger">*</span>
                              </Label>
                              <div className="form-icon position-relative">
                                <i>
                                  <FeatherIcon
                                    icon="key"
                                    className="fea icon-sm icons"
                                  />
                                </i>
                                <Input
                                  name="password"
                                  type="password"
                                  className="form-control ps-5"
                                  placeholder="Password"
                                  value={this.state.password}
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Reason for Deletion <span className="text-danger">*</span>
                              </Label>
                              <div className="form-icon position-relative">
                                <i>
                                  <FeatherIcon
                                    icon="message-square"
                                    className="fea icon-sm icons"
                                  />
                                </i>
                                <textarea
                                  name="reasonForDeletion"
                                  rows="4"
                                  className="form-control ps-5"
                                  placeholder="Please tell us why you want to delete your account..."
                                  value={this.state.reasonForDeletion}
                                  onChange={this.handleChange}
                                  required
                                ></textarea>
                              </div>
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="d-grid mt-3">
                              <button
                                type="submit"
                                className="btn btn-danger"
                                disabled={this.state.loading}
                              >
                                {this.state.loading ? "Processing..." : "Submit Deletion Request"}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default AccountDeletion;
